import { DeviceOrientation, PortsSubscription } from './types';
import portsApi from '../framework/ports/portsApi';

const DeviceOrientationFrontend = {
  getDeviceOrientation: (): Promise<DeviceOrientation> =>
    portsApi.invoke('DeviceOrientation.getDeviceOrientation'),
  getDeviceOrientationDependingOnScreenRatio: (): Promise<DeviceOrientation> =>
    portsApi.invoke(
      'DeviceOrientation.getDeviceOrientationDependingOnScreenRatio'
    ),
  getScreenSize: (): Promise<'small' | 'medium' | 'wide'> =>
    portsApi.invoke('DeviceOrientation.getScreenSize'),
  onScreenSizeChange: (callback: (size: string) => void): PortsSubscription =>
    portsApi.on('DeviceOrientation.onScreenSizeChange', callback),
};

export default DeviceOrientationFrontend;
